import React, { Component } from 'react';
import _ from 'lodash';

import { FormElement, FormList, FormListItem } from '../CommonFormComponents';
import AttachDocument from './AttachDocument';
import { DateInput } from '../DateInput';
import { renderToolTip } from '../tables/VerticalScrollBodyTable';
import { INDUSTRY } from '../../utilities/roanConstants';

import {
  showPrefectureInput,
  showRegionalDevelopmentBureau,
} from '../../utilities/companySafetyUtil';
import { wrapperValidExpirationDate } from '../../utilities/dateSelectorUtility';
import { messageUtility } from '../../utilities/messageUtility';

import {
  ATTACH_DOCUMENT_TYPE_COMPANY,
  PREFECTURE_GROUPS,
  REGIONAL_DEVELOPMENT_BUREAU_NONE,
} from '../../utilities/constants';

import { RadioButtonIcon } from '../icons/RadioButtonIcon';
import { ArrowDownIcon } from '../icons/ArrowDownIcon';
import { Description } from '../Description';

class CompanyConstructionIndustryForm extends Component {
  renderPermittedSourceSection = () => {
    const { checkboxList, validate, formEvents, formValues } = this.props;
    return (
      <FormElement
        validate={_.get(validate, 'messages.permitted_source_section')}
      >
        <div className='form-list-radio'>
          {_.map(checkboxList.construct_permit_source_types, type => (
            <div
              key={`form-key-${type.construct_permit_source_type}`}
              className='form-list-radio__item'
            >
              <label className='radio'>
                <input
                  type='radio'
                  id={`form-radio-permitted_source_section-${
                    type.construct_permit_source_type
                  }`}
                  value={Number(type.construct_permit_source_type)}
                  checked={
                    type.construct_permit_source_type ===
                      Number(_.get(formValues, 'permitted_source_section')) ||
                    ''
                  }
                  name='permitted_source_section'
                  onChange={e =>
                    formEvents.handleOnChange(
                      e,
                      'permitted_source_section',
                      () =>
                        formEvents.handleValidate(e, 'permitted_source_section')
                    )
                  }
                />
                <RadioButtonIcon className='icon--2x' />
                <span>
                  {
                    INDUSTRY.permissions.source[
                      type.construct_permit_source_type
                    ]['name']
                  }
                </span>
              </label>
            </div>
          ))}
        </div>
      </FormElement>
    );
  };
  renderPrefecture = () => {
    const { validate, formEvents, formValues } = this.props;
    return (
      <FormElement validate={_.get(validate, 'messages.prefectures_code_id')}>
        <div className='form-list-radio__item'>
          <select
            name='prefectures_code_id'
            onChange={e => formEvents.handleOnChange(e, 'prefectures_code_id')}
            onBlur={e => formEvents.handleValidate(e, 'prefectures_code_id')}
            defaultValue={formValues.prefectures_code_id}
          >
            <option value=''>選択してください</option>
            {_.map(PREFECTURE_GROUPS, region => (
              <optgroup key={region.label} label={region.label}>
                {_.map(region.prefectures, prefecture => (
                  <option key={prefecture.id} value={prefecture.id}>
                    {prefecture.name}
                  </option>
                ))}
              </optgroup>
            ))}
          </select>
          <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
        </div>
      </FormElement>
    );
  };
  renderRegionalDevelopmentBureau = () => {
    const { bureaux, formEvents, validate, formValues } = this.props;
    return (
      <FormElement
        validate={_.get(validate, 'messages.regional_development_bureau_id')}
      >
        <select
          name='regional_development_bureau_id'
          onChange={e =>
            formEvents.handleOnChange(e, 'regional_development_bureau_id')
          }
          onBlur={e =>
            formEvents.handleValidate(e, 'regional_development_bureau_id')
          }
        >
          <option value=''>{REGIONAL_DEVELOPMENT_BUREAU_NONE}</option>
          {_.map(bureaux, item => (
            <option
              key={`bureaux${item.id}`}
              value={item.id}
              selected={
                Number(formValues.regional_development_bureau_id) ===
                Number(item.id)
              }
            >
              {item.bureau_name}
            </option>
          ))}
        </select>
        <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
      </FormElement>
    );
  };
  renderConstructionIndustryPermissionSection = () => {
    const { checkboxList, validate, formEvents, formValues } = this.props;
    return (
      <FormElement
        validate={_.get(
          validate,
          'messages.construction_industry_permission_section'
        )}
      >
        <div className='form-list-radio'>
          {_.map(checkboxList.construct_permit_types, type => (
            <div
              key={`form-key-${type.construct_permit_type}`}
              className='form-list-radio__item'
            >
              <label className='radio'>
                <input
                  type='radio'
                  id={`form-radio-construction_industry_permission_section-${
                    type.construct_permit_type
                  }`}
                  value={type.construct_permit_type}
                  checked={
                    type.construct_permit_type ===
                      Number(
                        _.get(
                          formValues,
                          'construction_industry_permission_section'
                        )
                      ) || ''
                  }
                  name='construction_industry_permission_section'
                  onChange={e =>
                    formEvents.handleOnChange(
                      e,
                      'construction_industry_permission_section',
                      () =>
                        formEvents.handleValidate(
                          e,
                          'construction_industry_permission_section'
                        )
                    )
                  }
                />
                <RadioButtonIcon className='icon--2x' />
                <span>
                  {
                    INDUSTRY.permissions.construction[
                      type.construct_permit_type
                    ]['name']
                  }
                </span>
              </label>
            </div>
          ))}
        </div>
      </FormElement>
    );
  };
  renderNumberYear = () => {
    const { validate, formEvents, formValues } = this.props;
    return (
      <FormElement
        info='※和暦を数字のみで入力してください。例）平成31年の場合は「31」、令和元年の場合は「1」'
        validate={_.get(validate, 'messages.permission_number_l')}
      >
        <div className='form-list-container'>
          <div className='form-list-container--item'>
            <input
              type='text'
              name='permission_number_l'
              maxLength={2}
              className='form-list__input--short'
              value={_.get(formValues, 'permission_number_l')}
              onChange={e =>
                formEvents.handleOnChange(e, 'permission_number_l')
              }
              onBlur={e => formEvents.handleValidate(e, 'permission_number_l')}
            />
          </div>
        </div>
      </FormElement>
    );
  };
  renderPermissionNumber = () => {
    const { validate, formEvents, formValues } = this.props;
    return (
      <FormElement
        info={messageUtility.getMessage('I-000-146')}
        validate={_.get(validate, 'messages.permission_number_r')}
      >
        <div className='form-list-container'>
          <div className='form-list-container--item'>
            <span className='form-list-container--label form-list-container--label-number'>
              第
            </span>
            <input
              type='text'
              name='permission_number_r'
              value={_.get(formValues, 'permission_number_r')}
              onBlur={e => formEvents.handleValidate(e, 'permission_number_r')}
              onChange={e =>
                formEvents.handleOnChange(e, 'permission_number_r')
              }
              maxLength={20}
            />
            <span className='form-list-container--label'>号</span>
          </div>
        </div>
      </FormElement>
    );
  };
  renderLicenseUpdateDate = () => {
    const {
      formValues,
      formEvents,
      validate,
      readOnly,
      warningMsg,
    } = this.props;
    return (
      <DateInput
        dateString={this.dateFormat(formValues.license_update_date)}
        disabled={readOnly}
        onChangeValue={date =>
          formEvents.handleOnChangeDate(date, 'license_update_date')
        }
        isPreview={readOnly}
        info={
          !readOnly &&
          '※建設業許可を更新した最新の日付を入力してください。労務安全書類にはこの日付が出力されます。'
        }
        message={_.get(validate, 'messages.license_update_date')}
        onBlur={e => formEvents.handleValidate(e, 'license_update_date')}
        jpDelimiterChar={true}
        warning={_.get(warningMsg, 'license_update_date')}
      />
    );
  };

  renderLicenseLimitDate = () => {
    const {
      formValues: { license_limit_date },
    } = this.props;
    return (
      !!license_limit_date && (
        <DateInput
          dateString={license_limit_date}
          jpDelimiterChar={true}
          disabled={true}
          isPreview={true}
          warning={wrapperValidExpirationDate(
            license_limit_date,
            '許可',
            true,
            null,
            '許可（更新）年月日と添付書類'
          )}
        />
      )
    );
  };

  /**
   * 29業種のチェックボックスをレンダリングする
   * @param {object} otherIndustries: その他許可業種情報
   */
  renderAuthorizedIndustry(otherIndustries) {
    const { industryDefault, formValues, formEvents, validate } = this.props;

    // その他許可業種が選択可否
    let checkable = true;
    if (!_.isEmpty(otherIndustries)) {
      // その他許可業種があり、1件でも有効なその他許可業種があった場合には選択不可
      _.forEach(otherIndustries, industry => {
        if (!_.get(industry, '_destroy')) {
          checkable = false;
          return;
        }
      });
    }

    return (
      <FormElement
        validate={_.get(validate, 'messages.company_branch_permissions')}
      >
        <div className='form-list__industry'>
          {_.map(_.chunk(industryDefault, 10), (industryGroup, index) => (
            <div className='form-list__industry-group' key={index}>
              {_.map(industryGroup, industry => {
                const data = _.find(
                  _.get(formValues, 'company_branch_permissions'),
                  item =>
                    Number(item.authorized_industry_codes) ===
                      Number(industry.construct_permit_industry_type_code) &&
                    !_.get(item, '_destroy')
                );
                const isChecked = !_.isEmpty(data);
                return (
                  <div key={industry.construct_permit_industry_type_code}>
                    <label className='checkbox'>
                      <input
                        type='checkbox'
                        name='construct_permit_industry_type_code'
                        checked={isChecked}
                        disabled={!checkable}
                        onChange={e =>
                          formEvents.handleOnChangeAuthorizedIndustry(
                            e,
                            industry
                          )
                        }
                      />
                      <i className='i-square i-3x' />
                      {renderToolTip(
                        industry.construct_permit_industry_type_name
                      )}
                    </label>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </FormElement>
    );
  }

  chunkArr = (arr, sizeChunk) => {
    const size = _.size(arr);
    const itemLen = Math.floor(size / sizeChunk);
    const itemEm = size % sizeChunk;
    const result = [];
    let start = 0;
    for (let i = 0; i < sizeChunk; i++) {
      const sizeOfItem = i < itemEm ? itemLen + 1 : itemLen;
      const end = start + sizeOfItem;
      result[i] = arr.slice(start, end);
      start += sizeOfItem;
    }
    return result;
  };

  renderAuthorizedIndustryOther = otherIndustries => {
    const { formEvents, warningMsg } = this.props;
    return (
      <FormElement
        className='form-list__element form-list__element--authorized-other'
        warning={_.get(warningMsg, 'otherIndustry')}
      >
        {_.map(otherIndustries, industry => (
          <div className='form-list__other-industry'>
            <label className='checkbox'>
              <input
                type='checkbox'
                name='authorized_industry_codes'
                defaultChecked={!_.get(industry, '_destroy')}
                disabled={_.get(industry, '_destroy')}
                onChange={() =>
                  formEvents.handleOnChangeOtherAuthorizedIndustry(
                    _.get(industry, 'id')
                  )
                }
              />
              <i className='i-square-disabled i-3x' />
              <span>
                その他（{_.get(industry, 'authorized_industry_names')}）
              </span>
            </label>
          </div>
        ))}
      </FormElement>
    );
  };

  renderAttachment = () => {
    const {
      attachmentEvents,
      documentCodes,
      formValues,
      isCcusCreateForm,
    } = this.props;
    return (
      <React.Fragment>
        {isCcusCreateForm && (
          <Description type='primary' style={{ marginBottom: 12 }}>
            添付書類はCCUSから取得することができません。この画面で添付を行ってください。
          </Description>
        )}
        <AttachDocument
          companyDocuments={formValues.company_documents}
          documentCodes={_.filter(documentCodes, document => {
            return (
              document.file_typeL ===
              ATTACH_DOCUMENT_TYPE_COMPANY.CONSTRUCTION_PERMISSION
            );
          })}
          events={attachmentEvents}
          isFormListDefault
          indexId={ATTACH_DOCUMENT_TYPE_COMPANY.CONSTRUCTION_PERMISSION}
        />
      </React.Fragment>
    );
  };

  dateFormat = date => {
    return date ? date : '//';
  };

  render() {
    const formValues = this.props.formValues;
    const { isDuplicateNumberR } = this.props;
    const otherIndustries = _.filter(
      this.props.formValues.company_branch_permissions,
      data => !data.authorized_industry_codes
    );
    return (
      <div className='CompanyConstructionIndustryForm'>
        <FormList>
          {isDuplicateNumberR && (
            <FormListItem className='form-list__element--duplicate-record'>
              <div className='text--negative'>
                同一の内容で既に登録されている許可グループがあります。
              </div>
            </FormListItem>
          )}
          <FormListItem label='許可元区分' required={true} safetyDocItem={true}>
            {this.renderPermittedSourceSection()}
          </FormListItem>
          {showPrefectureInput(
            Number(_.get(formValues, 'permitted_source_section') || null)
          ) && (
            <FormListItem label='都道府県' required={true} safetyDocItem={true}>
              {this.renderPrefecture()}
            </FormListItem>
          )}
          {showRegionalDevelopmentBureau(
            Number(_.get(formValues, 'prefectures_code_id') || null)
          ) &&
            Number(this.props.formValues.permitted_source_section) ===
              INDUSTRY.permissions.source[2].id && (
              <FormListItem label='振興局' required={true} safetyDocItem={true}>
                {this.renderRegionalDevelopmentBureau()}
              </FormListItem>
            )}
          <FormListItem
            label='建設許可区分'
            required={true}
            safetyDocItem={true}
          >
            {this.renderConstructionIndustryPermissionSection()}
          </FormListItem>
          <FormListItem
            label='許可番号 年度'
            required={true}
            safetyDocItem={true}
          >
            {this.renderNumberYear()}
          </FormListItem>
          <FormListItem
            label='許可番号 固有番号'
            required={true}
            safetyDocItem={true}
          >
            {this.renderPermissionNumber()}
          </FormListItem>
          <FormListItem
            label='許可（更新）年月日'
            required={true}
            safetyDocItem={true}
          >
            {this.renderLicenseUpdateDate()}
          </FormListItem>
          <FormListItem label='有効期限年月日'>
            {this.renderLicenseLimitDate()}
          </FormListItem>
          <FormListItem
            label='許可業種'
            required={true}
            safetyDocItem={true}
            className={`form-list__item ${
              !_.isEmpty(otherIndustries) ? 'form-list__item--authorized' : ''
            }`}
          >
            {this.renderAuthorizedIndustry(otherIndustries)}
          </FormListItem>
          {!_.isEmpty(otherIndustries) && (
            <FormListItem label=' '>
              {this.renderAuthorizedIndustryOther(otherIndustries)}
            </FormListItem>
          )}
          <FormListItem label='添付書類'>
            <FormElement
              warning={
                _.isEmpty(formValues.company_documents) &&
                '添付書類が添付されておりません。'
              }
            >
              {this.renderAttachment()}
            </FormElement>
          </FormListItem>
        </FormList>
      </div>
    );
  }
}

export default CompanyConstructionIndustryForm;



// WEBPACK FOOTER //
// ./src/components/forms/CompanyConstructionIndustryForm.jsx